import { AppState } from '@reducers/rootReducer';
import { OrderedMap } from 'immutable';
import { Moments } from '../../Models/Moments';
import type { ID, ReduxAction } from '../../types';

export type SharedContactMomentsState = OrderedMap<ID, Moments>;
const initialSharedContactMomentsState = OrderedMap<ID, Moments>();

export const selectSharedContactInteractions = (contactUUID: ID) => (state: AppState) =>
  state.sharedData.moments.get(contactUUID, new Moments()).interactions;

export const selectSharedContactInteractionSummary = (contactUUID: ID) => (state: AppState) =>
  state.sharedData.moments.get(contactUUID, new Moments()).summary;

export function sharedContactMomentsReducer(
  state: SharedContactMomentsState = initialSharedContactMomentsState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_SHARED_CONTACT_MOMENTS_SUCCEEDED':
      return state.set(payload.contactUUID, new Moments(payload.response));

    default:
      return state;
  }
}
